import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { iterationsSelector } from 'state/selectors/iterations-picker';
import { Flex } from 'components/base/layout-components';
import { IterationMenuItem } from './IterationMenuItem';

const StyledMenu = styled(Flex)`
  flex-direction: column;
  padding-right: 1px;
  width: 30rem;
  height: 37rem;
  overflow: auto;
`;

const Iterations = ({ onChange }) => {
  const iterations = useSelector(iterationsSelector);

  const items = iterations
    .filter(({ isVisible }) => isVisible)
    .map((iteration, index) => {
      return (
        <IterationMenuItem
          key={index}
          iteration={iteration}
          onChange={onChange}
        />
      );
    });

  return (
    <StyledMenu data-testid='period-picker-iterations'>{items}</StyledMenu>
  );
};

export default Iterations;
